import TopazData from "../../../../src/components/topaz-data.js";
import * as React from 'react';
export default {
  TopazData,
  React
};